module.exports = __webpack_public_path__ + "img/32.31375627.jpg";